var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('LoggerList',{attrs:{"logger_type":"level","title":"Nivå","icon_marker_letter":"L"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }